import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { getSession, getParams, setParams, getCustomer, PARAM_KEYS } from "@/lib/track";

export default function Tracker() {
  const { pathname, search } = useLocation();
  const navigate = useNavigate();
  const isAdmin = pathname.startsWith("/admin");

  useEffect(() => {
    if (isAdmin) return;
    const sp = new URLSearchParams(search);
    const merged = new URLSearchParams(getParams());
    PARAM_KEYS.forEach((k) => {
      const v = sp.get(k);
      if (v) merged.set(k, v);
    });
    const qs = merged.toString();
    if (qs && search !== `?${qs}`) {
      setParams(qs);
      navigate(`${pathname}?${qs}`, { replace: true });
    }
  }, [pathname, search, isAdmin, navigate]);

  useEffect(() => {
    if (isAdmin) return;
    api.post("/track/event", { session: getSession(), type: "pageview", page: pathname, customer: getCustomer() }).catch(() => {});
  }, [pathname, isAdmin]);

  useEffect(() => {
    const handler = (e) => {
      if (window.location.pathname.startsWith("/admin")) return;
      const el = e.target.closest("a,button");
      if (!el) return;
      const target =
        el.getAttribute("data-testid") || (el.textContent || "").trim().replace(/\s+/g, " ").slice(0, 40);
      if (!target) return;
      api
        .post("/track/event", { session: getSession(), type: "click", page: window.location.pathname, target, customer: getCustomer() })
        .catch(() => {});
    };
    document.addEventListener("click", handler, true);
    return () => document.removeEventListener("click", handler, true);
  }, []);

  return null;
}
